import { render, staticRenderFns } from "./homeFootRight.vue?vue&type=template&id=ed93a32c&scoped=true"
import script from "./homeFootRight.vue?vue&type=script&lang=js"
export * from "./homeFootRight.vue?vue&type=script&lang=js"
import style0 from "./homeFootRight.vue?vue&type=style&index=0&id=ed93a32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed93a32c",
  null
  
)

export default component.exports